import type { SVGProps } from 'react';
const SvgPinLogoSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    viewBox="0 0 52 52"
    {...props}
  >
    <path
      fill="#1A1A1A"
      d="M42 20c0 7.283-9.75 20.25-14.025 25.6a2.518 2.518 0 0 1-3.95 0C19.75 40.25 10 27.283 10 20c0-8.833 7.167-16 16-16s16 7.167 16 16"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m18 12 .01 12.861c0 .251.015.502.055.753.05.341.145.744.345 1.166.504 1.06 1.104 1.69 1.673 2.23 1.144 1.081 2.283 1.63 3.062 1.995.68.322 1.644.706 2.852.995a14.7 14.7 0 0 0 2.858-.995c.78-.37 1.918-.914 3.062-1.994.57-.535 1.164-1.165 1.673-2.231.2-.422.295-.825.345-1.166a6 6 0 0 0 .055-.753L34 12zm14.526 1.393-.005 3.799H19.47l-.005-3.8h13.062Zm-1.109 8.228c.46.066.835.161 1.104.237V18.58H19.47l.005 3.97c.3.108.634.208.994.284 1.818.383 3.412.019 4.38-.303a59 59 0 0 1 1.874-.479l.074-.017c1.015-.24 1.538-.363 2.114-.428 1.334-.147 2.278-.02 2.507.014Zm-3.092 8.105c-.554.26-1.338.578-2.332.815-.99-.237-1.774-.55-2.333-.815q-.195-.091-.42-.2l-.015-.008 2.758-1.511 2.762 1.515a9 9 0 0 1-.42.204m4.171-4.576q.021-.199.02-.398l.005-1.445a8 8 0 0 0-1.009-.284c-1.818-.383-3.412-.019-4.38.303-.455.124-1.095.294-1.874.479l-.074.017c-1.015.24-1.538.363-2.114.428-1.334.147-2.278.02-2.507-.014a9 9 0 0 1-1.09-.232v.748q0 .199.02.398c.036.313.106.71.305 1.128.41.871.9 1.383 1.364 1.823q.337.313.66.555l.06-.034 4.11-2.25 4.107 2.25.065.038c.22-.16.44-.35.664-.559.465-.44.95-.956 1.364-1.823.2-.417.27-.815.304-1.128"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPinLogoSolid;
